import React from 'react';
import styled from 'styled-components';

const slugify = (str) => str.replace(/\s+/g, '-').toLowerCase();

const Tab = ({ currentTab, setCurrentTab, tabs, renderContent }) => {
  return (
    <>
      {tabs.map((t, i) => {
        const isSelected = (i === 0 && !currentTab) || currentTab === t;
        return (
          <React.Fragment key={t}>
            <div className='tab-btn-cell'>
              <Tab.TabItem
                aria-expanded={isSelected}
                className={isSelected ? 'selected' : ''}
                id={`tab-${slugify(t)}`}
                onClick={() => setCurrentTab(t)}
              >
                {t}
              </Tab.TabItem>
            </div>
            {isSelected && renderContent && (
              <div className='tab-content-panel'>{renderContent(t)}</div>
            )}
          </React.Fragment>
        );
      })}
    </>
  );
};

Tab.TabItem = styled.button`
  background-color: #e2e2ff;
  margin-bottom: 5px;
  padding: 7px 10px;
  font-weight: normal;
  cursor: pointer;
  border: none;
  font: inherit;
  color: inherit;
  text-align: left;
  display: block;
  width: 100%;

  &:focus {
    outline: 2px solid #333fb8;
    outline-offset: 2px;
  }
  &:focus:not(:focus-visible) {
    outline: none;
  }
  &:focus-visible {
    outline: 2px solid #333fb8;
    outline-offset: 2px;
  }

  &.selected {
    color: white;
    background-color: #333fb8;
    position: relative;

    &:after {
      content: '';
      position: absolute;
      width: 0;
      height: 0;
      border: 12px solid #333fb8;
      left: calc(100% - 1px);
      top: 4px;
      border-top-color: transparent;
      border-right-color: transparent;
      border-bottom-color: transparent;
    }
  }
`;

export default Tab;
